module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_9005.4052ce6b.png";